import { render } from "./LoaderLogin.vue?vue&type=template&id=1b7cd7f1&scoped=true"
import script from "./LoaderLogin.vue?vue&type=script&lang=js"
export * from "./LoaderLogin.vue?vue&type=script&lang=js"

import "./LoaderLogin.vue?vue&type=style&index=0&id=1b7cd7f1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7cd7f1"]])

export default __exports__